<template>
  <div
    :class="{
      admin: true,
      'toggle-sidebar': showSideIconsOnly,
      'hide-side': !hasSubMenu,
    }"
    ref="admin"
  >
    <header class="header">
      <div class="top-header">
        <div class="media-group mb-0 user-options no-border pointer">
          <img
            :src="company.company_logo"
            :alt="company.company_name"
            class="company-logo"
          />
          <div class="small-text user-switch relative" v-if="$user.isAdmin()">
            <el-select
              v-model="activeBranch"
              @change="switchActiveBranch"
              placeholder="Select Branch"
              size="mini"
              class="header-select"
              style="width: 246px"
              filterable
              remote
              :remote-method="searchBranch"
            >
              <el-option key="all" value="all" label="All Branches"></el-option>
              <el-option
                v-for="branch in filteredBranches"
                :key="branch.id"
                :label="branch.station_name"
                :value="branch.id"
              ></el-option>
            </el-select>
            <i
              class="el-icon-arrow-down is-reverse"
              style="font-size: 15px;"
            ></i>
          </div>
          <div class="small-text" v-else>
            {{ $user.getBranch().station_name }}
          </div>
        </div>
        <div
          v-if="requireSubscription"
          class="user-profile media-group mb-0 flex-v-stretch"
        >
          <div
            class="search-wrapper relative global-search"
            ref="global-search"
          >
            <el-select
              v-model="searchedEmployee"
              placeholder="Search Employees"
              v-closable="{
                exclude: ['button-search'],
                handler: 'closeExpandedSearch',
              }"
              :class="{ active: expandSearch, 'top-search': true }"
              filterable
              clearable
              remote
              :remote-method="searchEmployees"
              @change="gotoEmployeeProfile"
            >
              <el-option
                v-for="employee in employees"
                :key="employee.id"
                :label="employee.name"
                :value="employee.id"
              ></el-option>
            </el-select>

            <!--input type="text" placeholder="search" class="search"-->
            <img
              src="/img/search-icon.svg"
              alt="search icon"
              class="search-icon"
            />
          </div>
          <button
            class="pointer btn-expand"
            :class="{ 'not-active': expandSearch }"
            ref="button-search"
          >
            <img
              src="/img/search-icon.svg"
              alt=" search icon"
              @click="expandSearch = !expandSearch"
            />
          </button>
          <div id="google_translate_element2"></div>

          <div class="notification relative mr-20">
            <img src="/img/bell.svg" alt /> <a href class="badge no-line">0</a>
          </div>
          <div
            class="media-group mb-0 user-options pointer"
            @click="userDropdown = !userDropdown"
            ref="userDropdown"
          >
            <img
              :src="$user.getPicture()"
              :alt="$user.getFullName()"
              class="user-icon contact-icon small-icon"
            />
            <div class="small-text user-switch relative">
              <div class="flex">
                <h3 class="mr-10">{{ name }}</h3>
                <img src="/img/caret.svg" alt />
              </div>
              <ul
                :class="{ 'user-dropdown': true, show: userDropdown }"
                v-closable="{
                  exclude: ['userDropdown'],
                  handler: 'closeUserDropdown',
                }"
              >
                <router-link
                  to=""
                  v-if="$user.getActiveView() === 'ess' && $user.isAdmin()"
                  @click.native="switchProfile('admin')"
                  >Switch to Admin profile</router-link
                >
                <router-link
                  to=""
                  v-if="$user.getActiveView() === 'admin'"
                  @click.native="switchProfile('ess')"
                  >Self Service</router-link
                >
                <router-link
                  v-if="$user.getActiveView() === 'ess'"
                  :to="`/ess/profile/${$user.getEmployee().id}`"
                  >My Profile</router-link
                >
                <router-link
                  v-if="$user.getActiveView() === 'admin' && $user.isAdmin()"
                  :to="
                    `/admin/organization/employees/view/${
                      $user.getEmployee().id
                    }`
                  "
                  >My Profile</router-link
                >
                <router-link to="/ess/change-password"
                  >Change Password</router-link
                >
                <router-link to="/ess/support">Support</router-link>
                <!-- <router-link to="/ess/activity-logs"
                    >Activity History</router-link
                  > -->
                <router-link to="/companyurl" @click.native="logout()"
                  >Log Out</router-link
                >
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-h-bet mobile-header">
        <button
          :class="{ toggle: true, close: toggleMobile }"
          @click.prevent="toggleMobileNav"
        >
          <span></span>
        </button>
        <div class="mobile-module">
          <img
            :src="menuImg"
            :alt="menuImg"
            class="mobile-selected-module-img"
          />
          <el-select
            v-model="menuId"
            @change="switchModule"
            placeholder="Select Branch"
            size="mini"
            class="mobile-selected-module"
            style="width: 150px"
            filterable
            remote
            :remote-method="searchBranch"
          >
            <el-option
              v-for="route in routes"
              :key="route.id"
              :label="route.name"
              :value="route.id"
            ></el-option>
          </el-select>
        </div>
        <router-link :to="'/' + $user.getActiveView() + '/activity-history'">
          <img src="/img/time-history.svg" alt="activity history" />
        </router-link>
      </div>

      <div
        v-if="requireSubscription"
        class="nav relative"
        :class="{ nav: true, relative: true, show: toggleMobile }"
      >
        <router-link
          v-for="(link, index) in routes"
          :key="link.id"
          :to="link.url"
          :class="'nav-item active nav-item-' + (index + 1)"
          v-on:click.native.prevent="toggleDropDown(index + 1, link.url)"
        >
          <div class="media-group" v-if="!link.hide">
            <img :src="link.img" alt />
            <span class="relative">
              {{ link && link.name }}
              <img
                src="/img/caret-down-w.svg"
                alt
                class="caret"
                v-if="link.children.length"
              />
            </span>
            <ul class="sub-nav2" v-if="link.children.length">
              <li v-for="childLink in link.children" :key="childLink.id">
                <router-link :to="childLink.url">
                  <div class="media-group">
                    <img :src="childLink.img" alt="dashboard" />
                    <span>{{ childLink && childLink.name }}</span>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
        </router-link>
        <div class="mobile-module side">
          <img
            :src="menuImg"
            :alt="menuImg"
            class="mobile-selected-module-img"
          />
          <button @click.prevent="toggleMobileNav" class="pointer">
            <img
              src="/img/close-w.svg"
              alt="close navigation"
              class="toggle-close"
            />
          </button>
          <el-select
            v-model="menuId"
            @change="switchModule"
            placeholder="Select Branch"
            size="mini"
            class="mobile-selected-module"
            style="width: 150px"
            filterable
            remote
            :remote-method="searchBranch"
          >
            <el-option key="all" value="all" label="All Branches"></el-option>
            <el-option
              v-for="route in routes"
              :key="route.id"
              :label="route.name"
              :value="route.id"
            ></el-option>
          </el-select>
        </div>
        <nav class="sub-nav side">
          <router-link
            :to="link.url"
            class="nav-item"
            :title="capitalize(link.name)"
            v-for="link in subMenu"
            @click.native.prevent="routeOnMobile(link.url)"
            :key="link.id"
          >
            <div>
              <div class="media-group mb-0" v-if="!link.hide">
                <img :src="link.img" :alt="link.name" />
                <span v-if="link.name">{{
                  link && link.name.replace("-", " ").toLowerCase()
                }}</span>
              </div>
            </div>
          </router-link>
        </nav>
      </div>
    </header>
    <aside class="aside">
      <div class="aside-inner">
        <div class="flex flex-v-center flex-h-center">
          <LogoAnimated />
          <!-- <img src="/img/main-clock.svg" alt="tams logo" class="logo" /> -->
          <!--img src="/img/heckerbella.svg" alt="tams logo" class="logo" -->
        </div>
        <div
          class="toggle-carret pl-30 pointer mt-10 mb-10"
          @click="toggleSideBarIcons"
        >
          <img
            src="/img/chevrons-left.svg"
            alt
            :class="rotateArrow"
            class="arrow"
            @click="hideNav = !hideNav"
          />
        </div>
        <nav class="sub-nav">
          <router-link
            :to="link.url"
            class="nav-item"
            :title="capitalize(link.name)"
            v-for="link in subMenu"
            :key="link.id"
          >
            <div class="media-group mb-0" v-if="!link.hide">
              <img :src="link.img" :alt="link.name" />
              <span v-if="link.name">{{
                link && link.name.replace("-", " ").toLowerCase()
              }}</span>
            </div>
          </router-link>
        </nav>
      </div>
    </aside>
    <main class="main" ref="main">
      <div class="p-30">
        <div class="media-group current-links-main">
          <img
            :src="
              subMenuLink.trim()
                ? `/img/blue/${subMenuLink.replace(/ /g, '').toLowerCase()}.svg`
                : `/img/blue/${menuName.replace(/ /g, '').toLowerCase()}.svg`
            "
            :alt="subMenuLink"
          />
          <h2 class="blue no-bold">{{ subMenuName }}</h2>
        </div>
        <div class="media-group current-links-sub" v-if="hasSubMenu">
          <span class="bold menu-link">{{ menuName }}</span>
          <span class="slash" v-if="subMenuLink && menuName && !showSubMenuText"
            >/</span
          >
          <span
            v-if="subMenuLink && menuName && !showSubMenuText"
            class="sub-menu-link"
            >{{ subMenuName }}</span
          >
        </div>
        <slot></slot>
      </div>
    </main>
  </div>
</template>

<script>
import debounce from "lodash.debounce";
import { mapState as rootMapState } from "vuex";
import { capitalize } from "@/helpers/functions";
import { user } from "@/helpers";
import LogoAnimated from "./LogoAnimated";

export default {
  props: ["routes"],
  data() {
    return {
      expandSearch: true,
      requireSubscription: false,
      showSideIconsOnly: false,
      userId: null,
      dropDown: false,
      toggleMobile: false,
      currentWidth: window.innerWidth,
      dropDownWidth: 1318,
      mobileWidth: 600,
      subMenu: this.routes[0].children,
      menuId: null,
      menuName: "",
      menuImg: "",
      subMenuLink: "",
      managingBranches: this.$user.getManagingBranches(),
      filteredBranches: [],
      activeBranch: this.$user.getActiveBranch(),
      company: this.$user.getCompany(),
      hasSubMenu: false,
      userDropdown: false,
      mainWidth: null,
      searchedEmployee: null,
      hideNav: false,
      hideSide: false,
      subModulesNotToShow: new Set(["overtime", "appraisal"]),
      langLoader: false,
      langScriptHasLoaded: false,
    };
  },
  components: {
    LogoAnimated,
  },
  mounted() {
    this.toggleMobile = false;
    this.showSideIconsOnly = this.$localStorage.get("sideBarState");
    this.getSubMenuForCurrentRoute(this.$route.path);
    this.managingBranches = this.$user.getManagingBranches();
    this.filteredBranches = [...this.managingBranches];
    this.userId = this.$user.getEmployee().id;
    this.requireSubscription = user
      .getUser()
      .employee.company.account_type.includes("premium");
  },
  watch: {
    $route: function(newValue) {
      this.getSubMenuForCurrentRoute(newValue.path);
      this.mobile = false;
    },
  },
  computed: {
    ...rootMapState(["employees"]),
    name() {
      const isEss = this.$route.path.includes("ess");
      return isEss ? this.$user.getFullName() : "Admin";
    },
    subMenuName() {
      return this.subMenuLink.replace("-", " ");
    },
    rotateArrow() {
      let arrow = "rotate";
      if (this.hideNav === true) {
        return arrow;
      }
      return true;
    },
  },
  created() {
    const langScript = document.createElement("script");
    this.langLoader = true;
    langScript.setAttribute(
      "src",
      `https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit2`
    );
    document.head.appendChild(langScript);
    langScript.onload = () => {
      setTimeout(() => {
        this.langLoader = false;
      }, 800);
    };

    document.addEventListener("click", this.documentClick);
  },
  destroyed() {
    document.removeEventListener("click", this.documentClick);
  },

  methods: {
    capitalize,
    getSubMenuForCurrentRoute(routePath) {
      this.hasSubMenu = false;

      const route = this.routes.find(route => routePath.startsWith(route.url));
      this.hideSide = route.hideSide ? route.hideSide : false;
      this.subMenu = route
        ? route.children.filter(x => {
            return !(
              this.subModulesNotToShow.has(x.name.toLowerCase()) &&
              process.env.NODE_ENV === "production"
            );
          })
        : [];
      this.menuName = route ? route.name : "";
      this.menuId = route ? route.id : null;
      this.menuImg = route ? route.img : "";

      const childRoute = this.subMenu.filter(route =>
        routePath.startsWith(route.url)
      )[0];
      this.subMenuLink = childRoute ? childRoute.name : "";
      this.showSubMenuText = childRoute ? childRoute.hide : false;

      if (this.subMenu.length > 0) {
        this.hasSubMenu = true;
      }
    },
    switchModule() {
      const route = this.routes.find(route => route.id === this.menuId);
      this.hideSide = route.hideSide ? route.hideSide : false;
      this.subMenu = route
        ? route.children.filter(x => {
            return !(
              this.subModulesNotToShow.has(x.name.toLowerCase()) &&
              process.env.NODE_ENV === "production"
            );
          })
        : [];
      this.menuName = route ? route.name : "";
      this.menuImg = route ? route.img : "";
      if (route.url) {
        this.$router.push(route.url);
      }
    },
    routeOnMobile(link) {
      this.toggleMobileNav();
      this.$router.push(link);
    },
    closeExpandedSearch() {
      this.expandSearch = false;
    },
    closeUserDropdown() {
      this.userDropdown = false;
    },
    searchBranch: debounce(function(query) {
      if (query.trim() !== "") {
        this.filteredBranches = this.managingBranches.filter(item => {
          return (
            item.station_name.toLowerCase().indexOf(query.toLowerCase()) > -1
          );
        });
        return;
      }
      this.filteredBranches = this.managingBranches;
    }),
    toggleSideBarIcons() {
      const sideBarToggled = !this.showSideIconsOnly;
      this.$localStorage.set("sideBarState", sideBarToggled);
      this.showSideIconsOnly = sideBarToggled;
    },
    toggleMobileNav() {
      this.toggleMobile = !this.toggleMobile;
    },
    toggleDropDown(index, path) {
      const element = this.$el.querySelector(`.nav-item-${index}`);
      if (!element) return;

      if (
        window.innerWidth <= this.mobileWidth &&
        element.classList.contains("show-drop-down")
      ) {
        element.classList.remove("show-drop-down");
        return;
      }

      if (window.innerWidth <= this.mobileWidth) {
        element.classList.add("show-drop-down");
      }

      if (path) this.redirect(path);
    },
    redirect(path) {
      if (window.innerWidth < this.dropDownWidth) return;
      this.$router.push(path);
    },

    switchProfile(view) {
      this.$user.setActiveView(view);
      this.$router.push({
        name: view === "admin" ? "admin.home" : "ess",
      });
      this.langLoader = false;
    },

    logout() {
      this.$user.clearStorage();
      this.$router.push({ name: "companyUrl" });
    },

    switchActiveBranch() {
      // eslint-disable-next-line no-unused-vars
      let loading = this.$loading({
        lock: true,
        text: "Switching branch, please wait...",
      });

      this.$user.setActiveBranch(this.activeBranch);
      location.reload();
      loading = false;
      // setTimeout(() => {
      //   location.reload();
      // }, 500);
    },

    searchEmployees: debounce(function(searchQuery) {
      if (searchQuery === undefined || searchQuery === "") {
        return false;
      }

      this.$store
        .dispatch("searchEmployees", searchQuery)
        .then(() => {})
        .catch(error => {
          this.$notification.error(error.message);
        });
    }, 500),

    gotoEmployeeProfile() {
      this.$router.push({
        path: `/admin/organization/employees/view/${this.searchedEmployee}`,
      });
      this.searchedEmployee = null;
    },
  },
};
</script>

<style scoped>
/* user switch dropdown */

.user-switch .user-dropdown {
  display: none;
}

.user-switch .user-dropdown a {
  line-height: 29px;
  color: #333333;
  font-size: 14px;
  text-decoration: none;
  display: block;
  padding: 5px 20px;
  font-weight: 500;
}

.user-switch .user-dropdown a:hover {
  background-color: #eeeeee;
}

.user-switch .user-dropdown.show {
  position: absolute;
  display: block;
  right: 0;
  text-decoration: none;
  color: #333;
  width: 100%;
  top: -100;
  background-color: #fff;
  width: 150px;
  z-index: 200;
  min-height: 100px;
  padding: 10px 0px;
  width: 300px;
  border: 1px solid #f4f4f4;
  box-sizing: border-box;
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  margin-top: 15px;
}
.current-links-main h2 {
  text-transform: capitalize;
}

.current-links-sub > .menu-link {
  text-transform: capitalize;
  font-weight: 500;
  color: #333;
  margin-right: 5px;
}

.current-links-sub > .slash {
  margin-right: 5px;
}

.current-links-sub > .sub-menu-link {
  color: #888;
  font-weight: 500;
}

.current-links-sub {
  margin-bottom: 30px;
}
.mobile-header {
  display: none;
  align-items: center;
}

.mobile-module {
  margin-left: auto;
  margin-right: auto;
  position: relative;
}

.mobile-module.side {
  display: none;
}
.mobile-selected-module {
  margin-left: 41px;
}
.mobile-selected-module-img {
  margin-left: 50px;
  transform: translateY(-50%);
  top: 50%;
  position: absolute;
  z-index: 9;
}

.mobile-header .logo {
  color: #fff;
}
.pl-30 {
  padding-left: 30px;
}

.mt-40 {
  margin-top: 40px;
}

.admin.toggle-sidebar {
  grid-template-columns: auto minmax(0, 1fr);
}
.admin.toggle-sidebar .sub-nav .nav-item span {
  display: none;
  opacity: 0;
  transition: 300ms ease;
}

.admin .toggle-carret img {
  transform: rotate(0deg);
  transition: 300ms ease;
}

.admin .notification {
  border-left: 1px solid #d8dde4;
  padding: 5px;
  height: 100% !important;
  margin-right: 5px;
  display: flex;
}

.btn-expand > img {
  width: 15px;
}

.admin .notification > img {
  width: 18px;
}

.admin.toggle-sidebar .toggle-carret img {
  transform: rotate(180deg);
}

.admin.toggle-sidebar .logo {
  margin-top: 31px;
  width: 45px;
  transition: width 300ms ease;
}

.admin.toggle-sidebar .aside {
  /* padding-top: 77px; */
  width: 80px;
  overflow-x: hidden;
}

.admin.toggle-sidebar .table {
  width: 100%;
}

.table {
  width: 100%;
}

.sub-nav.side {
  display: none;
}

.sub-nav .nav-item {
  display: block;
  color: #fff;
  text-decoration: none;
  padding: 20px;
  font-size: 13px;
  position: relative;
  text-transform: capitalize;
  border-left: 5px solid transparent;
}

.sub-nav .nav-item img {
  width: 18px;
}

.sub-nav .nav-item.router-link-active:not(:empty),
.sub-nav .nav-item:hover {
  background-color: #101839;
  border-left-color: #066aff;
}

.admin {
  display: grid;
  min-height: 100vh;
  height: 100%;
  grid-template-columns: var(--sidebar-width) minmax(0, 1fr);
  background-color: #fafafa;
}

.admin .aside {
  min-height: 100vh;
  background-color: var(--deep-blue);
  width: var(--sidebar-width);
  transition: width 300ms ease;
  height: 100%;
  overflow: auto;
}

.admin .aside-inner {
  height: calc(100vh - 100px);
}

.admin.hide-side {
  grid-template-columns: 1fr;
}
.admin.hide-side .aside {
  display: none;
}

.admin.hide-side .nav .nav-item {
  margin-right: 10px;
}

.aside .logo {
  font-size: 40px;
  color: #fff;
  width: 70px;
  text-transform: uppercase;
}

.admin .main {
  /* padding: 30px; */
  min-height: 100vh;
  height: 100%;
  overflow: auto;
}

.admin .header {
  grid-column: 1/-1;
  padding-top: 5px;
}
.admin .top-header {
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 30px 0px 30px;
  height: 35px;
}

.admin .user-options {
  border-left: 1px solid #d8dde4;
  padding: 10px;
  height: 100% !important;
}

.admin .small-icon {
  width: 25px;
  height: 25px;
}

.admin .user-icon {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 100%;
}

.admin .top-search .el-input__inner {
  padding: 15px !important;
  border-radius: 40px !important;
  padding-left: 40px !important;
  background-color: #f6f6f6;
  border: none !important;
  /* width: 100% !important; */
  width: 100% !important;
}

.admin .top-search {
  width: 0 !important;
  transition: width 200ms ease;
  visibility: hidden;
}

.admin .top-search + img {
  top: 12px;
  width: 15px;
  visibility: hidden;
}

.admin .top-search.active {
  width: 400px !important;
  visibility: visible;
}

.btn-expand.not-active {
  display: none;
}

.admin .top-search.active + img {
  visibility: visible;
}

.admin .search-icon {
  position: absolute;
  left: 10px;
  top: 10px;
}

.admin .small-icon {
  width: 25px;
  height: 25px;
}

.admin .nav {
  background-color: var(--deep-blue);
  display: flex;
  padding: 8px;
  color: #fff;
  flex-wrap: wrap;
  position: relative;
  padding-left: calc(var(--sidebar-width) + 30px);
}

.admin .nav .nav-item {
  color: #fff;
  text-decoration: none;
  display: block;
  position: relative;
  font-size: 13px;
}

.admin .nav .nav-item img {
  width: 18px;
}

.admin .nav .nav-item:not(:last-child) {
  margin-right: 15px;
}

.admin .nav a.nav-item:last-of-type {
  margin-right: 35px;
  margin-left: auto;
}
.admin .nav .nav-item.router-link-active:after {
  position: absolute;
  background-color: #fff;
  content: "";
  width: 100%;
  height: 5px;
  display: block;
  left: 0;
  bottom: -10px;
}

.admin .nav .nav-item:after {
  position: absolute;
  background-color: #fff;
  content: "";
  width: 0;
  height: 5px;
  display: block;
  left: 0;
  bottom: -10px;
  transition: 300ms ease;
}

.admin .nav .nav-item:hover:after {
  width: 100%;
}

.admin .sub-nav2 {
  position: absolute;
  list-style-type: none;
  top: 100%;
  margin: 0;
  padding: 0;
  min-width: 200px;
  width: 100%;
  display: none;
  z-index: 200;
}

.caret {
  display: none;
}

@media (max-width: 1269px) {
  .admin .aside {
    display: none;
  }

  .admin .nav .nav-item:not(:last-child) {
    margin-right: 30px !important;
  }

  .admin {
    grid-template-columns: 1fr;
  }

  .admin .nav {
    padding-left: 40px;
  }

  .caret {
    display: block;
    position: absolute;
    top: 4px;
    right: -20px;
    width: 8px !important;
  }

  .admin .nav .nav-item:after {
    display: none;
  }

  .admin .nav .nav-item.router-link-active:after {
    display: none;
  }

  .admin .sub-nav2 a {
    display: block;
    color: #fff;
    padding: 15px 20px;
    background-color: var(--deep-blue);
    text-decoration: none;
    text-transform: capitalize;
  }

  .admin .nav .nav-item:hover .sub-nav2 {
    display: block;
  }

  .admin .sub-nav2 li {
    display: block;
  }

  .admin .sub-nav2 a:hover {
    background-color: #101839;
  }

  .admin .toggle {
    position: absolute;
    display: inline-block;
    cursor: pointer;
    padding: 0 8px 5px;
    margin: 0;
    outline: none;
    border: none;
    left: 20px;
    background-color: transparent;
    display: none;
    z-index: 50001;
  }

  .admin .toggle span {
    position: relative;
    width: 25px;
    height: 2px;
    border-radius: 4px;
    transition: 300ms ease;
    display: inline-block;
    background-color: #fff;
    /* margin-top: -4px; */
    display: inline-block;
  }

  .admin .toggle span:before,
  .admin .toggle span:after {
    position: absolute;
    top: -6px;
    content: "";
    width: 25px;
    height: 2px;
    transition: 300ms ease;
    right: 0;
    background-color: #fff;
  }

  .admin .toggle span:after {
    top: 6px;
  }

  .admin .toggle.close span {
    /* background-color: transparent; */
    display: none;
  }

  /* .admin .toggle.close span:before {
    transform-origin: 50% 50%;
    transform: rotate3d(0, 0, 1, -45deg);
    top: 0;
  } */

  /* .admin .toggle.close span:after {
    transform-origin: 50% 50%;
    transform: rotate3d(0, 0, 1, 45deg);
    top: 0;
  } */

  @media (max-width: 890px) {
    .admin .nav .nav-item:hover .sub-nav2 {
      display: none;
    }
    .admin .header {
      padding-top: 0px;
    }
    .admin .top-header {
      display: none;
    }

    .admin .mobile-header {
      background-color: var(--deep-blue);
      padding: 10px 30px;
      margin: 0;
      position: relative;
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
    .admin .mobile-header .logo {
      font-size: 25px;
    }

    .admin .nav {
      display: block;
      position: fixed;
      width: 50vw;
      min-height: 100vh;
      transform: translateX(-100%);
      transition: 300ms ease;
      top: 0;
      bottom: 0;
      z-index: 2000;
      padding: 0;
      padding-top: 50px;
    }

    .sub-nav.side {
      display: block;
    }
    .sub-nav.side .nav-item {
      padding: 10px;
    }
    .mobile-module.side {
      display: inline-block;
      margin-left: 5px;
      margin-bottom: 20px;
    }

    .mobile-module.side .mobile-selected-module {
      margin-left: 5px;
    }
    .mobile-module.side .mobile-selected-module-img {
      margin-left: 12px;
    }
    .toggle-close {
      opacity: 0;
      position: fixed;
      right: 30px;
      top: 20px;
    }
    .admin .nav.show {
      transform: translateX(0);
    }

    .admin .nav.show .toggle-close {
      opacity: 1;
    }
    .admin .nav .media-group {
      display: flex;
    }

    .admin .nav .nav-item {
      width: 100%;
      display: none;
    }

    .admin .sub-nav .nav-item {
      display: block;
    }

    .admin .toggle {
      display: block;
      z-index: 5001;
    }
  }
}
.company-logo {
  object-fit: contain;
}

.rotate {
  transform: scaleX(-1);
}
</style>

<style>
.el-select.mobile-selected-module .el-input .el-input__inner {
  padding: 20px 10px 20px 50px !important;
  background-color: #233169 !important;
  color: #fff !important;
  border: 0.75px solid #656f95 !important;
  border-radius: 2px !important;
}
body:not(_) {
  overflow-y: hidden !important;
}

#google_translate_element2 {
  margin-top: 10px;
  margin-right: 0px !important;
  min-width: 200px;
}

.goog-te-gadget .goog-te-combo {
  margin: 4px 0;
  border-left: 1px solid #d8dde4;
  border-right: none;
}
</style>
